import React, {useEffect, useMemo, useRef, useState} from 'react'
import {BotApi} from '../services/botApi.js'

const SUCCESS_MESSAGE = 'Você foi descadastrado com sucesso'

export default function DescadastraPage() {
    const [status, setStatus] = useState('loading')
    const [error, setError] = useState('')
    const apiRef = useRef(null)

    const sessionId = useMemo(() => {
        if (typeof window === 'undefined') return null
        const params = new URLSearchParams(window.location.search)
        return params.get('sessionId')
    }, [])

    useEffect(() => {
        document.body.classList.add('descadastra-active')
        return () => document.body.classList.remove('descadastra-active')
    }, [])

    useEffect(() => {
        let cancelled = false

        if (!sessionId) {
            setStatus('error')
            setError('Sessão inválida. Verifique o link recebido.')
            return undefined
        }

        apiRef.current = new BotApi()

        const descadastrar = async () => {
            try {
                await apiRef.current.login()
                await apiRef.current.descadastrarSessao(sessionId)
                if (!cancelled) {
                    setStatus('success')
                }
            } catch (err) {
                if (cancelled) return
                setStatus('error')
                setError(err?.message || 'Não foi possível concluir o descadastramento da sessão.')
            }
        }

        descadastrar()

        return () => {
            cancelled = true
        }
    }, [sessionId])

    return (<main className='descadastra-page' role='main'>
        <div
            className='descadastra-page__content'
            aria-live='assertive'
            aria-busy={status === 'loading'}
        >
            {status === 'error' && (<p className='descadastra-page__text descadastra-page__text--error'>
                {error}
            </p>)}

            {status === 'success' && (<>
            <span className='descadastra-page__icon' aria-hidden='true'>
              <svg viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='32' cy='32' r='32'/>
                <polyline points='18 34 28 44 46 24'/>
              </svg>
            </span>
                <p className='descadastra-page__text'>{SUCCESS_MESSAGE}</p>
            </>)}

            <span className='descadastra-page__sr-only' role='status'>
          {status === 'loading' ? 'Processando seu descadastramento...' : ''}
        </span>
        </div>
    </main>)
}
